import type { InsightItem } from "@/types";

export const mockInsights: InsightItem[] = [
  {
    id: "in-1",
    title: "Commitment coverage",
    summary: "Model shows headroom to increase coverage without impacting agility.",
    value: "62%",
    trend: "up",
  },
  {
    id: "in-2",
    title: "Idle compute",
    summary: "Several instance families show sustained low utilization in non-prod.",
    trend: "flat",
  },
  {
    id: "in-3",
    title: "Data transfer",
    summary: "Cross-region egress is a top-three driver week over week.",
    trend: "down",
  },
];
